import { useEffect } from 'react';
import { toast } from 'react-hot-toast';

enum ToastStatus {
  SUCCESS = 'success',
  ERROR = 'error',
}

export interface ToastData {
  status: ToastStatus;
  title?: string;
  message: string;
}

const useToast = (data: ToastData, onSuccess?: () => void) => {
  useEffect(() => {
    if (data) {
      const { status, title, message } = data;
      const toastMessage = `${title ? `${title}\n` : ''}${message}`;

      if (status === ToastStatus.ERROR) {
        toast.error(toastMessage);
      } else {
        toast.success(toastMessage);
        if (onSuccess) {
          onSuccess();
        }
      }
    }
  }, [data]);
};

export default useToast;
